// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wnpj","questions":"styles_questions__1Qt61","footer":"styles_footer__2GB-b"};